/*       */
import { isObject } from 'app/utils/utils';

/**
 * Creates and manipulates the query's options to send to our API.
 */
class OptionsBuilder {
    options;
    config;

    /**
     * @param options the initial options.
     */
    constructor(options, config) {
        this.options = options || {};
        this.config = config || { legacyWhere: false };
    }

    /**
     * Adds a filter.
     *
     * @param condition the condition to add.
     * @return this builder.
     */
    filter(condition) {
        const filterByProp = this.config.legacyWhere ? 'where' : 'filterBy';
        let filterBy = this.options[filterByProp];
        if (isObject(filterBy)) {
            filterBy = [filterBy, condition];
        } else {
            filterBy = [...(filterBy || []), condition];
        }
        const nextOptions = { ...this.options };
        nextOptions[filterByProp] = filterBy;
        this.options = nextOptions;
        return this;
    }
    /**
     * Adds a filter.
     *
     * @param condition the condition to add.
     * @return this builder.
     */
    removeFilterByField(fieldName) {
        const filterByProp = this.config.legacyWhere ? 'where' : 'filterBy';
        const filterBy = (this.options[filterByProp] || []).filter(filter => filter.field !== fieldName);
        const nextOptions = { ...this.options, filterBy };
        this.options = nextOptions;
        return this;
    }

    /**
     * Sets the specified order if the query does not specify any order.
     *
     * @param order the default order.
     * @return this builder.
     */
    defaultOrder(order) {
        if (!this.options.orderBy) {
            this.options.orderBy = Array.isArray(order) ? order : [order];
        }
        return this;
    }

    /**
     * Sets the start and stop indexes if the query does not specify them.
     *
     * @param startIndex the default start index.
     * @param stopIndex the default stop index.
     * @return this builder.
     */
    defaultStartStopIndexs(startIndex, stopIndex) {
        if (!(this.options.startIndex >= 0)) {
            this.options.startIndex = startIndex;
        }
        if (!(this.options.stopIndex >= 0)) {
            this.options.stopIndex = stopIndex;
        }
        return this;
    }

    /**
     * @return the options.
     */
    populate(options) {
        this.options = {
            ...this.options,
            ...options,
        };
        return this;
    }

    /**
     * @return the options.
     */
    build() {
        return this.options;
    }
}

export default OptionsBuilder;
